var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 519,
    height: 328,
    viewBox: "0 0 519 328",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12488_226152)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_12488_226152)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M88.2305 331.822C119.428 322.118 155.294 288.014 195.021 261.736C252.425 223.765 298.769 242.668 324.515 265.964C353.294 292.005 423.256 328.265 469.177 331.676C472.785 331.724 476.417 331.772 480.075 331.822C476.633 332.016 472.988 331.959 469.177 331.676C250.287 328.761 124.652 328.086 88.2305 331.822Z",
    fill: "url(#paint0_linear_12488_226152)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M387.051 115.672C387.051 115.672 374.854 19.1674 302.893 88.5501C210.645 177.489 148.637 0.721531 80.2043 72.876C42.8182 112.294 141.61 200.45 75.6312 246.844C9.65198 293.237 63.5689 327.97 63.5689 327.97H438.216C438.216 327.97 477 330.802 479.936 281.177C482.867 231.552 437.783 230.951 465.764 168.851C493.745 106.75 395.844 155.199 387.051 115.672Z",
    fill: "url(#paint1_linear_12488_226152)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12488_226152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.756 147.314C215.756 153.35 210.929 158.231 204.908 158.231C204.804 158.231 203.921 158.231 197.433 158.231C192.917 158.231 185.702 158.231 174.178 158.231H168.676C161.461 158.388 155.699 152.562 155.699 145.529C155.699 138.443 161.513 132.564 168.832 132.932C175.113 113.092 203.87 115.873 206.309 136.396C211.708 137.078 215.756 141.697 215.756 147.314Z",
    fill: "url(#paint2_linear_12488_226152)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204.907 158.231C210.877 158.231 215.756 153.35 215.756 147.314C215.756 141.278 210.877 136.396 204.907 136.396C198.938 136.396 194.059 141.278 194.059 147.314C194.059 153.35 198.938 158.231 204.907 158.231Z",
    fill: "url(#paint3_linear_12488_226152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.208 158.337C197.849 158.337 206.518 149.624 206.518 138.864C206.518 128.104 197.849 119.391 187.208 119.391C176.567 119.391 167.898 128.104 167.898 138.864C167.898 149.624 176.515 158.337 187.208 158.337Z",
    fill: "url(#paint4_linear_12488_226152)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M177.758 331.865C198.729 324.49 234.098 309.511 260.802 289.539C299.388 260.68 304.421 266.452 329.586 280.881C353.202 294.423 404.153 329.145 435.293 331.777C437.235 331.806 439.187 331.835 441.15 331.865C439.292 331.984 437.335 331.949 435.293 331.777C287.252 329.542 202.321 329.017 177.758 331.865Z",
    fill: "url(#paint5_linear_12488_226152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.773 331.873C137.744 325.266 173.114 311.847 199.818 293.956C238.404 268.103 243.437 273.274 268.602 286.2C292.218 298.331 343.169 329.436 374.309 331.794C376.251 331.82 378.203 331.846 380.166 331.873C378.308 331.979 376.351 331.948 374.309 331.794C226.268 329.792 141.337 329.321 116.773 331.873Z",
    fill: "url(#paint6_linear_12488_226152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.707 331.885C224.678 325.29 271.82 311.93 295.978 290.598C326.176 263.934 335.403 264.794 360.568 277.696C384.493 289.962 431.922 329.44 462.488 331.822C464.019 331.843 465.556 331.864 467.1 331.885C465.612 331.97 464.073 331.946 462.488 331.822C313.677 329.81 228.339 329.331 203.707 331.885Z",
    fill: "url(#paint7_linear_12488_226152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0938 327.381H420.089",
    stroke: "#9CACCE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.59 327.381H476.71",
    stroke: "#9CACCE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("rect", {
    x: 219.23,
    y: 287.436,
    width: 24.5391,
    height: 40.5285,
    rx: 5.04336,
    fill: "url(#paint8_linear_12488_226152)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.608,
    height: 40.417,
    rx: 5.04336,
    transform: "matrix(0.863603 -0.504173 0.495838 0.868415 358.09 296.354)",
    fill: "url(#paint9_linear_12488_226152)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_12488_226152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.601 172.104C237.57 166.797 242.542 163.222 247.884 163.992L370.003 181.588C375.344 182.358 379.163 187.2 378.668 192.575L366.966 319.656C366.438 325.38 361.249 329.475 355.561 328.656L222.229 309.443C216.541 308.623 212.654 303.22 213.686 297.569L236.601 172.104Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M219.405 266.309L369.701 287.657L366.746 319.657C366.217 325.381 361.026 329.478 355.338 328.66L222.227 309.526C216.541 308.708 212.655 303.31 213.685 297.661L219.405 266.309Z",
    fill: "url(#paint10_linear_12488_226152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.723 154.636C261.453 150.358 265.869 147.821 270.443 148.477L352.843 160.299C357.417 160.955 360.978 164.638 361.485 169.236L362.666 179.929L255.7 164.582L259.723 154.636Z",
    fill: "url(#paint11_linear_12488_226152)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8793,
    cy: 18.9561,
    rx: 18.8793,
    ry: 18.9561,
    transform: "matrix(0.989703 0.143218 -0.135242 0.990824 241.27 226.176)",
    stroke: "#9CACCE",
    strokeWidth: 2.52168
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.968 238.402L257.417 250.547L245.168 234.238",
    stroke: "#9CACCE",
    strokeWidth: 2.52168
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.711 287.423L219.373 266.1L223.774 242.478L290.187 252.004C294.491 252.622 298.182 255.422 299.946 259.408C301.709 263.393 305.398 266.193 309.7 266.811L370.853 275.603L369.711 287.423Z",
    fill: "url(#paint12_linear_12488_226152)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.79204,
    cy: 7.83584,
    rx: 7.79204,
    ry: 7.83584,
    transform: "matrix(0.989785 0.142626 -0.135803 0.990743 231.285 280.709)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.79204,
    cy: 7.83584,
    rx: 7.79204,
    ry: 7.83584,
    transform: "matrix(0.989785 0.142626 -0.135803 0.990743 338.207 295.902)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 58.9516,
    height: 13.1337,
    rx: 6.56683,
    transform: "matrix(0.989846 0.14218 -0.136229 0.990683 263.461 286.951)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.2565,
    height: 37.1615,
    rx: 3.1521,
    transform: "matrix(0.989807 0.142465 -0.135956 0.990722 385.75 209.117)",
    fill: "url(#paint13_linear_12488_226152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.141 198.842L390.992 200.692C393.749 201.089 395.677 203.648 395.298 206.407L394.64 211.203",
    stroke: "url(#paint14_linear_12488_226152)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.156 253.916L383.387 255.533C386.144 255.93 388.686 254.015 389.064 251.255L389.723 246.457",
    stroke: "url(#paint15_linear_12488_226152)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.2565,
    height: 37.1615,
    rx: 3.1521,
    transform: "matrix(-0.989807 -0.142465 -0.135956 0.990722 224.629 186.254)",
    fill: "url(#paint16_linear_12488_226152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.793 178.504L221.942 176.654C219.185 176.257 216.643 178.172 216.265 180.932L215.607 185.727",
    stroke: "url(#paint17_linear_12488_226152)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.566 233.115L214.336 231.498C211.579 231.101 209.651 228.542 210.029 225.783L210.687 220.984",
    stroke: "url(#paint18_linear_12488_226152)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.547 294.107L395.304 296.512L396.602 291.701L401.359 294.107L404.819 287.372H412.172L415.199 282.08",
    stroke: "url(#paint19_linear_12488_226152)"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 12.0898,
    y2: -0.5,
    transform: "matrix(0.214644 -0.976692 0.975671 0.219239 382.762 280.77)",
    stroke: "url(#paint20_linear_12488_226152)"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 12.6234,
    y2: -0.5,
    transform: "matrix(0.822285 -0.569076 0.560527 0.828136 386.652 285.328)",
    stroke: "url(#paint21_linear_12488_226152)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129,
    y1: 249.5,
    x2: 180,
    y2: 249.5,
    stroke: "#9CACCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.99 218.102C148.99 218.102 143.918 216.175 141.384 225.782C138.851 235.389 131.246 233.494 129.343 244.401C127.44 255.309 129.949 266.217 128.077 271.345C126.204 276.474 120.471 284.842 124.907 295.087C129.343 305.332 139.482 311.767 153.426 307.915C167.37 304.062 180.696 305.351 182.575 282.897C184.453 260.444 166.097 265.573 166.734 255.953C167.37 246.334 176.872 243.119 169.903 234.138C162.934 225.157 157.862 227.721 154.692 221.948C151.523 216.175 148.99 218.102 148.99 218.102Z",
    fill: "#B0E4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.357 327.338L150.972 225.494H150.632L147.73 327.533L151.357 327.338Z",
    fill: "#4D6173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.432 301.59L126.137 284.83L149.783 299.198L148.432 301.59Z",
    fill: "#4D6173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.136 269.338L133.574 256.891L151.142 267.559L150.136 269.338Z",
    fill: "#4D6173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.143 289.62L173.438 272.859L149.785 287.221L151.143 289.62Z",
    fill: "#4D6173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.346 250.836L165.999 239.824L150.461 249.26L151.346 250.836Z",
    fill: "#4D6173"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12488_226152",
    x: 133.699,
    y: 108.438,
    width: 104.059,
    height: 82.7969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12488_226152"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12488_226152",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_12488_226152",
    x: 185.52,
    y: 143.887,
    width: 213.191,
    height: 212.873,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.67451 0 0 0 0 0.721569 0 0 0 0 0.792157 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12488_226152"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12488_226152",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12488_226152",
    x1: -206.635,
    y1: 212.106,
    x2: 594.179,
    y2: 649.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12488_226152",
    x1: 42.8164,
    y1: 55.1035,
    x2: 233.162,
    y2: 432.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AACBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12488_226152",
    x1: 185.728,
    y1: 135.47,
    x2: 185.708,
    y2: 158.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12488_226152",
    x1: 192.904,
    y1: 134.046,
    x2: 202.638,
    y2: 144.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12488_226152",
    x1: 166.09,
    y1: 129.928,
    x2: 181.292,
    y2: 135.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12488_226152",
    x1: -20.4462,
    y1: 249.766,
    x2: 522.73,
    y2: 540.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12488_226152",
    x1: -81.4306,
    y1: 258.326,
    x2: 433.485,
    y2: 566.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5DEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12488_226152",
    x1: 5.50299,
    y1: 249.766,
    x2: 548.68,
    y2: 540.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8EDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12488_226152",
    x1: 222.453,
    y1: 288.136,
    x2: 258.606,
    y2: 291.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12488_226152",
    x1: 3.23175,
    y1: 0.699003,
    x2: 39.4822,
    y2: 4.34538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12488_226152",
    x1: 103.494,
    y1: 236.266,
    x2: 424.19,
    y2: 418.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12488_226152",
    x1: 178.417,
    y1: 129.721,
    x2: 352.441,
    y2: 281.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_12488_226152",
    x1: 222,
    y1: 242.223,
    x2: 258.417,
    y2: 324.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81A8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F84F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_12488_226152",
    x1: -12.9856,
    y1: -11.3254,
    x2: 30.8255,
    y2: -9.10767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_12488_226152",
    x1: 380.461,
    y1: 199.349,
    x2: 403.854,
    y2: 210.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_12488_226152",
    x1: 374.31,
    y1: 254.053,
    x2: 397.592,
    y2: 250.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_12488_226152",
    x1: -12.9856,
    y1: -11.3254,
    x2: 30.8255,
    y2: -9.10767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_12488_226152",
    x1: 232.426,
    y1: 178.336,
    x2: 207.101,
    y2: 182.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_12488_226152",
    x1: 223.459,
    y1: 232.639,
    x2: 201.795,
    y2: 223.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_12488_226152",
    x1: 393.784,
    y1: 282.33,
    x2: 427.762,
    y2: 291.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_12488_226152",
    x1: 1.58774,
    y1: 0.0172948,
    x2: 5.19336,
    y2: 7.21897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_12488_226152",
    x1: 1.65782,
    y1: 0.0172948,
    x2: 5.16926,
    y2: 7.34042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12488_226152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 519,
    height: 328,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12488_226152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 437.66,
    height: 273.033,
    fill: "white",
    transform: "translate(42.8164 55.1035)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.eb74fbd0bc529c70dc8271285764c69a.svg";
export { ForwardRef as ReactComponent };